/* ============================================================
   CDC Product — variant + gallery + form behaviour
   ============================================================ */
(function () {
  'use strict';

  function init(section) {
    if (!section || section.dataset.cdcInit === 'true') return;
    section.dataset.cdcInit = 'true';

    var sectionId = section.dataset.sectionId;
    var colorOptionName = section.dataset.colorOptionName || 'Color';
    var sizeOptionName = section.dataset.sizeOptionName || 'Size';
    var colorOptionIndex = parseInt(section.dataset.colorOptionIndex, 10);
    if (isNaN(colorOptionIndex)) colorOptionIndex = -1;

    var variantsScript = section.querySelector('[data-cdc-variants]');
    var galleriesScript = section.querySelector('[data-cdc-galleries]');

    var variants = [];
    var galleries = {};
    try {
      if (variantsScript) variants = JSON.parse(variantsScript.textContent);
      if (galleriesScript) galleries = JSON.parse(galleriesScript.textContent);
    } catch (e) {
      console.warn('[cdc-product] failed to parse data', e);
    }

    // Preload all variant gallery images so color swap is instant.
    // We use new Image() to push each src into the browser cache.
    (function preloadGalleries() {
      var preloaded = {};
      Object.keys(galleries).forEach(function (key) {
        (galleries[key] || []).forEach(function (img) {
          if (img && img.src && !preloaded[img.src]) {
            preloaded[img.src] = true;
            var preImg = new Image();
            if (img.src_2x) {
              preImg.srcset = img.src + ' 1x, ' + img.src_2x + ' 2x';
            }
            preImg.src = img.src;
          }
        });
      });
    })();

    var form = section.querySelector('.js-product-form');
    var idInput = section.querySelector('[data-cdc-variant-id]');
    var atcBtn = section.querySelector('[data-cdc-atc]');
    var atcLabel = section.querySelector('[data-cdc-atc-label]');
    var priceEl = section.querySelector('[data-cdc-price]');
    var compareEl = section.querySelector('[data-cdc-compare-price]');
    var colorValueEl = section.querySelector('[data-cdc-color-value]');
    var stockLabelEl = section.querySelector('[data-cdc-stock-label]');
    var stockQtyEl = section.querySelector('[data-cdc-stock-qty]');
    var galleryGrid = section.querySelector('[data-cdc-gallery-grid]');

    var stockThreshold = 10;
    var stockLowLabel = 'Going Fast!';
    var stockInStockLabel = 'In Stock';
    var addToCartLabel = atcLabel ? atcLabel.textContent.trim() : 'ADD TO CART';
    var soldOutLabel = 'SOLD OUT';
    var unavailableLabel = 'UNAVAILABLE';
    // Read defaults from the section if present
    var stockEl = section.querySelector('[data-cdc-stock]');
    if (stockEl) {
      // Keep current threshold defaults
    }

    // Determine current option selection from selected buttons
    function getCurrentSelection() {
      var selections = [];
      var options = section.querySelectorAll('[data-cdc-option-index]');
      options.forEach(function (optRow) {
        var idx = parseInt(optRow.dataset.cdcOptionIndex, 10);
        var selectedBtn = optRow.querySelector('[data-cdc-swatch].is-selected, [data-cdc-size].is-selected, [data-cdc-option-button].is-selected');
        if (selectedBtn) {
          selections[idx] = selectedBtn.dataset.optionValue;
        }
      });
      return selections;
    }

    function findVariant(selections) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var match = true;
        for (var j = 0; j < selections.length; j++) {
          if (selections[j] !== undefined && v.options[j] !== selections[j]) {
            match = false;
            break;
          }
        }
        if (match) return v;
      }
      return null;
    }

    function updateSizeAvailability(selections) {
      // For each size button: check if there's any variant matching current color + this size that is available
      var sizeRow = null;
      var sizeOptionIdx = -1;
      var optRows = section.querySelectorAll('[data-cdc-option-index]');
      optRows.forEach(function (row) {
        var sizeBtn = row.querySelector('[data-cdc-size]');
        if (sizeBtn) {
          sizeRow = row;
          sizeOptionIdx = parseInt(row.dataset.cdcOptionIndex, 10);
        }
      });
      if (!sizeRow) return;

      var sizeBtns = sizeRow.querySelectorAll('[data-cdc-size]');
      sizeBtns.forEach(function (btn) {
        var sizeValue = btn.dataset.optionValue;
        // build a hypothetical selection
        var hypothetical = selections.slice();
        hypothetical[sizeOptionIdx] = sizeValue;
        var match = findVariant(hypothetical);
        if (match && match.available) {
          btn.classList.remove('is-unavailable');
          btn.disabled = false;
        } else {
          btn.classList.add('is-unavailable');
          // don't fully disable — let user click and we'll show sold-out state on ATC
        }
      });
    }

    function setGalleryForColor(colorValue) {
      if (!galleryGrid) return;
      if (!colorValue) return;
      var key = String(colorValue).toLowerCase().trim();
      var imgs = galleries[key];
      if (!imgs || imgs.length === 0) return;

      galleryGrid.classList.add('is-swapping');
      // Build new gallery HTML
      var html = '';
      imgs.forEach(function (img) {
        html += '<div class="cdc-pd__gallery-item">' +
          '<img src="' + img.src + '" ' +
          (img.src_2x ? 'srcset="' + img.src + ' 1x, ' + img.src_2x + ' 2x" ' : '') +
          'alt="' + (img.alt || '') + '" ' +
          'loading="eager" ' +
          (img.width ? 'width="' + img.width + '" ' : '') +
          (img.height ? 'height="' + img.height + '"' : '') +
          '>' +
          '</div>';
      });

      galleryGrid.innerHTML = html;
      requestAnimationFrame(function () {
        galleryGrid.classList.remove('is-swapping');
      });
    }

    function updateForVariant(variant) {
      if (variant) {
        if (idInput) idInput.value = variant.id;

        if (priceEl) priceEl.textContent = variant.price_money || '';
        if (compareEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            compareEl.textContent = variant.compare_at_price_money;
            compareEl.hidden = false;
            compareEl.removeAttribute('hidden');
          } else {
            compareEl.textContent = '';
            compareEl.hidden = true;
            compareEl.setAttribute('hidden', '');
          }
        }

        if (atcBtn && atcLabel) {
          if (variant.available) {
            atcBtn.disabled = false;
            atcBtn.removeAttribute('aria-disabled');
            atcLabel.textContent = addToCartLabel;
          } else {
            atcBtn.disabled = true;
            atcBtn.setAttribute('aria-disabled', 'true');
            atcLabel.textContent = soldOutLabel;
          }
        }

        // Update stock display
        if (stockLabelEl && variant.inventory_management) {
          var qty = variant.inventory_quantity || 0;
          if (qty > 0 && qty <= stockThreshold) {
            stockLabelEl.textContent = stockLowLabel;
            if (stockEl) stockEl.classList.add('is-low');
          } else if (qty > 0) {
            stockLabelEl.textContent = stockInStockLabel;
            if (stockEl) stockEl.classList.remove('is-low');
          } else {
            stockLabelEl.textContent = soldOutLabel;
            if (stockEl) stockEl.classList.add('is-low');
          }
        }
        if (stockQtyEl && variant.inventory_management) {
          var qty2 = variant.inventory_quantity || 0;
          stockQtyEl.textContent = qty2 > 0 ? (qty2 + ' in stock') : '';
        }

        // Update color value display
        if (colorValueEl && colorOptionIndex >= 0) {
          colorValueEl.textContent = variant.options[colorOptionIndex] || '';
        }

        // Update URL without reload (so refresh keeps variant)
        if (window.history && window.history.replaceState) {
          try {
            var url = new URL(window.location.href);
            url.searchParams.set('variant', variant.id);
            window.history.replaceState({}, '', url.toString());
          } catch (e) {}
        }

        // Fire variant change event for sticky ATC etc.
        section.dispatchEvent(new CustomEvent('on:variant:change', {
          bubbles: true,
          detail: { variant: variant }
        }));
      } else {
        if (atcBtn && atcLabel) {
          atcBtn.disabled = true;
          atcBtn.setAttribute('aria-disabled', 'true');
          atcLabel.textContent = unavailableLabel;
        }
      }
    }

    // SWATCH click handler
    section.querySelectorAll('[data-cdc-swatch]').forEach(function (sw) {
      sw.addEventListener('click', function () {
        var row = sw.closest('[data-cdc-option-index]');
        if (row) {
          row.querySelectorAll('[data-cdc-swatch]').forEach(function (s) {
            s.classList.remove('is-selected');
          });
        }
        sw.classList.add('is-selected');

        var selections = getCurrentSelection();
        var variant = findVariant(selections);

        // If current variant unavailable, try to find first available variant with this color
        if (!variant || !variant.available) {
          var colorVal = sw.dataset.optionValue;
          var fallback = variants.filter(function (v) {
            return v.available && v.options[colorOptionIndex] === colorVal;
          })[0];
          if (fallback) {
            variant = fallback;
            // Update other option buttons to match
            row && row.parentNode && updateOptionButtonsForVariant(fallback);
          }
        }

        // Color swap gallery
        setGalleryForColor(sw.dataset.optionValue);
        updateSizeAvailability(getCurrentSelection());
        updateForVariant(variant);
      });
    });

    // SIZE click handler
    section.querySelectorAll('[data-cdc-size]').forEach(function (sz) {
      sz.addEventListener('click', function () {
        var row = sz.closest('[data-cdc-option-index]');
        if (row) {
          row.querySelectorAll('[data-cdc-size]').forEach(function (s) {
            s.classList.remove('is-selected');
          });
        }
        sz.classList.add('is-selected');

        var selections = getCurrentSelection();
        var variant = findVariant(selections);
        updateForVariant(variant);
      });
    });

    // GENERIC option-button click handler
    section.querySelectorAll('[data-cdc-option-button]').forEach(function (b) {
      b.addEventListener('click', function () {
        var row = b.closest('[data-cdc-option-index]');
        if (row) {
          row.querySelectorAll('[data-cdc-option-button]').forEach(function (s) {
            s.classList.remove('is-selected');
          });
        }
        b.classList.add('is-selected');
        var selections = getCurrentSelection();
        var variant = findVariant(selections);
        updateForVariant(variant);
      });
    });

    function updateOptionButtonsForVariant(variant) {
      section.querySelectorAll('[data-cdc-option-index]').forEach(function (row) {
        var idx = parseInt(row.dataset.cdcOptionIndex, 10);
        var targetValue = variant.options[idx];
        if (targetValue === undefined || targetValue === null) return;

        row.querySelectorAll('[data-cdc-swatch], [data-cdc-size], [data-cdc-option-button]').forEach(function (btn) {
          if (btn.dataset.optionValue === targetValue) {
            btn.classList.add('is-selected');
          } else {
            btn.classList.remove('is-selected');
          }
        });
      });
    }

    // FORM submit — add to cart via fetch + dispatch theme's cart events
    if (form) {
      form.addEventListener('submit', function (evt) {
        evt.preventDefault();
        if (!atcBtn) return;
        if (atcBtn.getAttribute('aria-disabled') === 'true') return;

        atcBtn.setAttribute('aria-disabled', 'true');
        atcBtn.classList.add('is-loading');
        var formData = new FormData(form);

        // include sections param if theme supports cart drawer refresh
        // Most Cornerstone-based themes support /cart/add.js with sections refresh.

        fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: formData
        })
          .then(function (resp) { return resp.json(); })
          .then(function (data) {
            atcBtn.classList.remove('is-loading');
            atcBtn.removeAttribute('aria-disabled');

            if (data && data.status) {
              // Shopify error response (e.g. inventory issue)
              console.warn('[cdc-product] add to cart error', data);
              alert(data.description || data.message || 'Could not add to cart.');
              return;
            }

            // Dispatch event(s) for cart drawer to update
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            document.dispatchEvent(new CustomEvent('on:cart:add', { bubbles: true, detail: { product: data } }));

            // Refresh cart-form so the drawer renders the new items
            var cartForm = document.querySelector('cart-drawer cart-form[data-ajax-update="true"], cart-form[data-ajax-update="true"]');
            if (cartForm && typeof cartForm.refresh === 'function') {
              try { cartForm.refresh(); } catch (e) { /* ignore */ }
            }

            // Open the cart drawer. This theme has a known constructor bug:
            // <cart-drawer> reads .js-overlay in its constructor, but .js-overlay
            // is rendered AFTER overlay-group in theme.liquid, so this.overlay is
            // null at construction time and .open() throws. We rebind it here.
            function openCartDrawer() {
              var drawer = document.querySelector('.js-cart-drawer, cart-drawer');
              if (!drawer) return false;
              if (!drawer.overlay) {
                drawer.overlay = document.querySelector('.js-overlay');
              }
              if (typeof drawer.open === 'function') {
                try { drawer.open(atcBtn); return true; } catch (e) {
                  console.warn('[cdc-product] drawer.open failed', e);
                }
              }
              if (drawer.classList) {
                drawer.classList.add('is-open', 'open');
                drawer.setAttribute('open', '');
                drawer.setAttribute('aria-hidden', 'false');
                var overlay = document.querySelector('.js-overlay');
                if (overlay) overlay.classList.add('is-visible');
                return true;
              }
              return false;
            }

            // Try opening immediately, then again after a tick if first attempt fails
            // (covers the case where cart-form refresh re-rendered the drawer node)
            if (!openCartDrawer()) {
              document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { bubbles: true, detail: { opener: atcBtn } }));
            }
            setTimeout(openCartDrawer, 100);

            // Refresh cart count badge
            fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root + 'cart.js' : '/cart.js')
              .then(function (r) { return r.json(); })
              .then(function (cart) {
                document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
                document.querySelectorAll('[data-cart-count], .cart-count, .js-cart-count').forEach(function (el) {
                  el.textContent = cart.item_count;
                });
              })
              .catch(function () { /* ignore */ });
          })
          .catch(function (err) {
            atcBtn.classList.remove('is-loading');
            atcBtn.removeAttribute('aria-disabled');
            console.error('[cdc-product] add to cart failed', err);
            // Fallback: submit form natively
            form.submit();
          });
      });
    }

    // Init: ensure availability is correct on load
    updateSizeAvailability(getCurrentSelection());

    initShippingUsp(section);
  }

  function getNextShipDate(fromDate) {
    var date = new Date(fromDate.getTime());
    var day = date.getDay();
    var daysToAdd = day === 5 ? 3 : day === 6 ? 2 : 1;
    date.setDate(date.getDate() + daysToAdd);
    return date;
  }

  function initShippingUsp(section) {
    var usp = section.querySelector('[data-cdc-shipping-usp]');
    if (!usp) return;

    var dateEl = usp.querySelector('[data-cdc-ship-date]');
    var countryEl = usp.querySelector('[data-cdc-ship-country]');
    var fallback = usp.getAttribute('data-shipping-suffix') || 'Fast Worldwide Shipping';

    if (dateEl) {
      var shipDate = getNextShipDate(new Date());
      dateEl.textContent = shipDate.toLocaleDateString('en-US', {
        weekday: 'short',
        month: 'short',
        day: 'numeric'
      });
    }

    if (!countryEl) return;

    fetch('https://get.geojs.io/v1/ip/geo.json')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data || !data.country_code) throw new Error('no country');
        var code = data.country_code.toUpperCase();
        countryEl.textContent = 'Fast ' + code + ' Shipping';
      })
      .catch(function () {
        countryEl.textContent = fallback;
      });
  }

  function initAll() {
    document.querySelectorAll('.cdc-product[data-section-id]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init when section is added/updated in the theme editor
  document.addEventListener('shopify:section:load', function (evt) {
    var el = evt.target.querySelector ? evt.target.querySelector('.cdc-product[data-section-id]') : null;
    if (el) init(el);
  });
})();